<template>
  <div class="custom-card">
    <v-toolbar-title class="mb-4 py-2" style="border-bottom: 1px solid #d4dbe0">
      <v-row dense>
        <v-col
          cols="12"
          md="6"
          :lg="this.$store.state.CARGO.id == 1 ? 4 : 6"
          :xl="this.$store.state.CARGO.id == 1 ? 4 : 6">
          <span>PAGOS: PROGRAMA UNIVERSIDAD</span>
        </v-col>

        <v-col v-if="this.$store.state.CARGO.id == 1" cols="12" md="6" lg="2" xl="2">
          <div class="d-flex">
            <v-switch style="margin-top: -4px" v-model="mostrarTodasSedes" hide-details label="Ver todos"></v-switch>
          </div>
        </v-col>

        <v-col cols="12" md="6" lg="2" xl="2">
          <v-select
            v-model="estadoProgramaUniversidad"
            :items="[
              { value: null, text: 'Todos' },
              { value: 'inscrito', text: 'Inscrito' },
              { value: 'pendiente', text: 'Pendiente de Inscripción' },
            ]"
            label="Estado"
            outlined
            dense
            hide-details
            @change="listarRestableciendoPagina">
          </v-select>
        </v-col>

        <v-col cols="12" md="6" lg="2" xl="2">
          <v-select
            v-model="tieneModulos"
            :items="[
              { value: null, text: 'Todos' },
              { value: true, text: 'Sí' },
              { value: false, text: 'No' },
            ]"
            label="Tiene Módulos"
            outlined
            dense
            hide-details
            @change="listarRestableciendoPagina">
          </v-select>
        </v-col>

        <v-col cols="12" md="6" lg="2" xl="2">
          <v-select
            v-model="tienePlanPago"
            :items="[
              { value: null, text: 'Todos' },
              { value: true, text: 'Sí' },
              { value: false, text: 'No' },
            ]"
            label="Tiene Plan de Pago"
            outlined
            dense
            hide-details
            @change="listarRestableciendoPagina">
          </v-select>
        </v-col>

        <v-col cols="12" md="6" lg="3" xl="3">
          <v-select
            v-model="sedeUniversidadId"
            :items="sedesUniversidades"
            item-text="nombre"
            item-value="id"
            label="Sede Universidad"
            outlined
            dense
            hide-details
            clearable
            @change="listarRestableciendoPagina">
            <template v-slot:item="{ item }">
              <v-list-item-content>
                <v-list-item-title class="font-weight-medium">{{ item.nombre }}</v-list-item-title>
                <v-list-item-subtitle class="subtitle-2 text-uppercase">
                  <small>{{ item.institucion.nombre }}</small>
                </v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </v-select>
        </v-col>

        <v-col cols="12" md="6" lg="4" xl="3">
          <v-pagination
            class="custom-pagination"
            v-model="pagina"
            :length="metadatos?.totalPaginas || 0"
            :total-visible="10"
            @input="listar"></v-pagination>
        </v-col>

        <v-col cols="12" md="6" lg="2" xl="2">
          <v-select
            :items="[10, 25, 50, 75, 100, 500]"
            label="Items por página"
            v-model="itemsPorPagina"
            outlined
            dense
            hide-details
            :disabled="items.length == 0"
            @change="cambiarPagina" />
        </v-col>

        <v-col cols="12" md="6" lg="2" xl="2">
          <span class="subtitle-2">
            {{ textoPaginacion }}
          </span>
        </v-col>
      </v-row>
    </v-toolbar-title>

    <v-row dense>
      <v-col cols="12" md="9" xl="10">
        <template v-if="tipo == tiposProgramasUniversidadesLayouts.NACIONAL && permisosAcademicosNacional">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" class="mx-1" color="primary" title="Registrar" small>
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item link>
                <v-list-item-title
                  @click="$refs.modalFormularioProgramaUniversidadRef.abrir(accionesCrud.REGISTRAR, [])">
                  Versión 1
                </v-list-item-title>
              </v-list-item>

              <v-list-item link>
                <v-list-item-title
                  @click="$refs.modalFormularioProgramaUniversidadV2Ref.abrir(accionesCrud.REGISTRAR, [])">
                  Versión 2
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" class="mx-1" title="Editar" small :disabled="item == null">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item link>
                <v-list-item-title
                  @click="$refs.modalFormularioProgramaUniversidadRef.abrir(accionesCrud.EDITAR, item)">
                  Versión 1
                </v-list-item-title>
              </v-list-item>

              <v-list-item link>
                <v-list-item-title
                  @click="$refs.modalFormularioProgramaUniversidadV2Ref.abrir(accionesCrud.EDITAR, item)">
                  Versión 2
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-btn
            small
            class="mx-1"
            :disabled="item == null"
            title="Eliminar"
            @click="
              () => confirmacionAccion(accionesAConfirmar.ELIMINAR, nombreItem, `${item.codigo} ${item.programaNombre}`)
            ">
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <!-- <v-btn
            small
            class="mx-1"
            :disabled="item == null"
            title="Módulos Programa"
            @click="$refs.modalModulosProgramaRef.abrir(accionesCrud.EDITAR, item)">
            <v-icon>mdi-view-module</v-icon>

            Módulos
          </v-btn> -->

          <!-- Reemplazado por Conceptos Universidades -->
          <!-- <v-btn
            small
            class="mx-1"
            :disabled="item == null"
            title="Costos Programa"
            @click="$refs.modalCostosProgramaRef.abrir(accionesCrud.EDITAR, item)">
            <v-icon>mdi-cash</v-icon>

            Costos
          </v-btn> -->

          <v-btn
            small
            class="mx-1"
            title="Consolidar"
            :disabled="
              item == null ||
              [estadosProgramasUniversidades.INSCRITO, estadosProgramasUniversidades.NO_EJECUTADO_DISPONIBLE].includes(
                item.estado,
              )
            "
            @click="confirmarConsolidacion">
            <v-icon>mdi-check</v-icon>

            Consolidar
          </v-btn>
        </template>

        <v-btn
          class="mx-1"
          title="Ver"
          small
          :disabled="item == null"
          @click="$refs.modalMostrarProgramaUniversidadRef.abrir(item)">
          <v-icon>mdi-eye</v-icon>
        </v-btn>

        <v-btn
          small
          class="mx-1"
          title="Ver PDF"
          :disabled="item == null"
          :loading="descargandoPdf"
          @click="obtenerPdfProgramaUniversidad">
          <v-icon>mdi-file-pdf-box</v-icon>

          PDF
        </v-btn>

        <v-btn class="mx-1" title="Recargar" small @click="listar">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>

        <v-btn
          v-if="permisosAcademicosNacional || permisosPresupuestos1 || permisosContabilidadNacional"
          small
          class="mx-1"
          :disabled="item == null"
          title="Plan de Pago"
          @click="$refs.modalFormEstablecerPlanPagoProgramaUniversidadRef.abrir(item)">
          <v-icon>mdi-cash</v-icon>

          Plan de Pago
        </v-btn>

        <v-btn
          v-if="permisosAcademicosNacional"
          small
          class="mx-1"
          :disabled="item == null"
          title="Documento CEUB"
          @click="$refs.modalFormAgregarCEUBRef.abrir(item)">
          <v-icon>mdi-file-document</v-icon>

          CEUB
        </v-btn>

        <v-btn
          small
          class="mx-1"
          :disabled="item == null"
          title="Ver Programas"
          @click="$refs.modalMostrarProgramasRef.abrir(accionesCrud.EDITAR, item)">
          <v-icon>mdi-file-document-multiple-outline</v-icon>

          Programas
        </v-btn>

        <v-btn
          small
          class="mx-1"
          :disabled="item == null"
          title="Inscripciones Programa Universidad"
          @click="$refs.modalInscripcionesProgramaUniversidadRef.abrir(accionesCrud.EDITAR, item)">
          <v-icon>mdi-file-document-multiple-outline</v-icon>

          Inscripciones Programa Univ.
        </v-btn>

        <v-btn
          v-if="
            permisosPresupuestos1 ||
            permisosPresupuestos2 ||
            permisosGestionEmpresarial ||
            permisosContabilidadNacional ||
            permisosAcademicosNacional
          "
          small
          class="mx-1"
          title="Solicitudes de Pago"
          :disabled="item == null || item.estado !== estadosProgramasUniversidades.INSCRITO"
          @click="handleSolcitudesPagos">
          <v-icon>mdi-text-box-multiple-outline</v-icon>

          Solicitudes de Pago
        </v-btn>

        <v-btn
          small
          class="mx-1"
          :disabled="item == null || item.programas.length === 0"
          title="Inscripciones de Programas Vinculados"
          @click="$refs.modalVisualizarInscripcionesRef.abrir(accionesCrud.EDITAR, item)">
          <v-icon>mdi-school</v-icon>

          Inscripciones de Programas Vinculados
        </v-btn>

        <v-btn
          v-if="permisosAcademicosNacional"
          small
          class="mx-1"
          title="Exportar Programas Universidad"
          :disabled="descargandoExcel"
          :loading="descargandoExcel"
          @click="obtenerExcelProgramasUniversidades">
          <v-icon>mdi-file-excel</v-icon>

          Descargar Excel
        </v-btn>

        <v-menu offset-y v-if="permisosAcademicosNacional">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              class="ma-1"
              title="Descargar Excel Inscritos Consolidados"
              small
              :disabled="descargandoExcelInscritosConsolidados"
              :loading="descargandoExcelInscritosConsolidados">
              Excel Inscritos Consolidados
            </v-btn>
          </template>

          <v-list>
            <v-list-item link>
              <v-list-item-title @click="obtenerExcelProgramasUniversidadesInscritosConsolidados('enero')">
                <v-icon>mdi-file-excel</v-icon>

                Enero
              </v-list-item-title>
            </v-list-item>

            <v-list-item link>
              <v-list-item-title @click="obtenerExcelProgramasUniversidadesInscritosConsolidados('febrero')">
                <v-icon>mdi-file-excel</v-icon>

                Febrero
              </v-list-item-title>
            </v-list-item>

            <v-list-item link>
              <v-list-item-title @click="obtenerExcelProgramasUniversidadesInscritosConsolidados('marzo')">
                <v-icon>mdi-file-excel</v-icon>

                Marzo
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-menu offset-y v-if="permisosAcademicosNacional">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              class="ma-1"
              title="Descargar Excel Inscritos Reportados"
              small
              :disabled="descargandoExcelInscritosReportados"
              :loading="descargandoExcelInscritosReportados">
              Excel Inscritos Reportados
            </v-btn>
          </template>

          <v-list>
            <v-list-item link>
              <v-list-item-title @click="obtenerExcelProgramasUniversidadesInscritosReportados('enero')">
                <v-icon>mdi-file-excel</v-icon>

                Enero
              </v-list-item-title>
            </v-list-item>

            <v-list-item link>
              <v-list-item-title @click="obtenerExcelProgramasUniversidadesInscritosReportados('febrero')">
                <v-icon>mdi-file-excel</v-icon>

                Febrero
              </v-list-item-title>
            </v-list-item>

            <v-list-item link>
              <v-list-item-title @click="obtenerExcelProgramasUniversidadesInscritosReportados('marzo')">
                <v-icon>mdi-file-excel</v-icon>

                Marzo
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>

      <v-col cols="12" md="3" xl="2">
        <v-text-field
          dense
          outlined
          hide-details
          v-model="searchQuery"
          append-icon="mdi-magnify"
          label="Buscar"
          clearable
          @input="buscar"></v-text-field>
      </v-col>

      <v-col cols="12">
        <ListadoProgramaUniversidad ref="listadoRef" :items="items" :cargando="cargando" @selectItem="selectItem" />
      </v-col>
    </v-row>

    <ModalFormularioProgramaUniversidad ref="modalFormularioProgramaUniversidadRef" @actualizarListado="listar" />

    <ModalFormularioProgramaUniversidadV2 ref="modalFormularioProgramaUniversidadV2Ref" @actualizarListado="listar" />

    <ConfirmacionAccion
      ref="confirmacionRef"
      max-width="1200"
      :titulo="confirmacion.titulo"
      :realizandoAccion="confirmacion.realizandoAccion"
      @aceptar="confirmacion.fnAceptar">
      <template>
        <p v-html="confirmacion.mensaje"></p>

        <v-alert v-if="!inscritosReportadosProgramaUniversidad" class="font-weight-bold mt-4" type="error" dense>
          No hay programas vinculados con inscripciones reportadas para el Programa Universidad seleccionado.
        </v-alert>

        <v-simple-table v-else dense>
          <thead>
            <th>ID Programa</th>
            <th>Programa</th>
            <th>Inscritos</th>
            <th>Reportado Por</th>
            <th>Reportado En</th>
          </thead>

          <tbody>
            <tr v-for="programa in inscritosReportadosProgramaUniversidad.programas" :key="programa.id">
              <td width="100">{{ programa.id }}</td>
              <td>{{ programa.nombreCompuesto }}</td>
              <td width="80">{{ programa.cantidadInscritos }}</td>
              <template v-if="!programa.programaReportado">
                <td colspan="2" class="text-center" width="400">No reportado</td>
              </template>

              <template v-else>
                <td width="250">{{ programa.programaReportado.reportadoPor }}</td>
                <td width="150">
                  {{
                    new Date(programa.programaReportado.creadoEn).toLocaleString('es-BO', {
                      year: 'numeric',
                      month: '2-digit',
                      day: '2-digit',
                      hour: '2-digit',
                      minute: '2-digit',
                      second: '2-digit',
                    })
                  }}
                </td>
              </template>
            </tr>

            <tr>
              <td colspan="2" class="font-weight-bold text-right">Total Inscritos Reportados:</td>
              <td class="font-weight-bold">{{ totalInscritosReportados }}</td>
              <td colspan="2"></td>
            </tr>
          </tbody>
        </v-simple-table>
      </template>
    </ConfirmacionAccion>

    <ModalInscripcionesProgramaUniversidad ref="modalInscripcionesProgramaUniversidadRef" :nombreRecurso="nombreItem" />

    <ModalSolicitudesPagos ref="modalSolicitudesPagosRef" :nombreRecurso="nombreItem2" />

    <ModalCostosPrograma ref="modalCostosProgramaRef" :nombreRecurso="nombreItem3" @actualizarListado="listar" />

    <ModalMostrarProgramas ref="modalMostrarProgramasRef" :nombreRecurso="nombreItem4" />

    <ModalModulosPrograma ref="modalModulosProgramaRef" :nombreRecurso="nombreItem5" @actualizarListado="listar" />

    <ModalMostrarProgramaUniversidadV2 ref="modalMostrarProgramaUniversidadRef" />

    <ModalFormEstablecerPlanPagoProgramaUniversidad
      ref="modalFormEstablecerPlanPagoProgramaUniversidadRef"
      @actualizarListado="listar" />

    <ModalFormAgregarCEUB ref="modalFormAgregarCEUBRef" @actualizarListado="listar" />

    <ModalVisualizarInscripciones
      ref="modalVisualizarInscripcionesRef"
      :universidadId="item?.sedeUniversidad?.universidadId"
      nombreRecurso="Inscripciones de Programas Vinculados" />

    <ModalVerPdf ref="modalVerPdfRef" />

    <notifications group="notifications" position="top right" />
  </div>
</template>

<script>
import ListadoProgramaUniversidad from '../components/ListadoProgramaUniversidad.vue';
import ModalFormularioProgramaUniversidadV2 from '../components/ProgramaUniversidad/ModalFormularioProgramaUniversidadV2.vue';
import ProgramaUniversidadService from '../services/programa-universidad.service';
import layoutMixin from '../mixins/layout.mixin';
import apiConsumerMixin from '../mixins/api-consumer.mixin';
import ModalInscripcionesProgramaUniversidad from '../components/ModalInscripcionesProgramaUniversidad.vue';
import ModalSolicitudesPagos from '../components/ModalSolicitudesPagos.vue';
import ModalCostosPrograma from '../components/ModalCostosPrograma.vue';
import { ESTADOS_PROGRAMAS_UNIVERSIDADES, TIPOS_PROGRAMAS_UNIVERSIDADES_LAYOUTS } from '../utils/constantes';
import ModalMostrarProgramas from '../components/ModalMostrarProgramas.vue';
import ModalModulosPrograma from '../components/ModalModulosPrograma.vue';
import ModalMostrarProgramaUniversidadV2 from '../components/ProgramaUniversidad/ModalMostrarProgramaUniversidadV2.vue';
import ModalFormEstablecerPlanPagoProgramaUniversidad from '../components/ModalFormEstablecerPlanPagoProgramaUniversidad.vue';
import SedeUniversidadService from '../services/sede-universidad.service';
import { mapGetters } from 'vuex';
import ModalFormAgregarCEUB from '../components/ModalFormAgregarCEUB.vue';
import ProgramaUniversidadExcelService from '../services/programa-universidad-excel.service';
import ModalVisualizarInscripciones from '../components/ModalVisualizarInscripciones.vue';
import ModalVerPdf from '../components/ModalVerPdf.vue';
import ProgramaUniversidadPdfV2Service from '../services/programa-universidad-pdf-v2.service';
import ModalFormularioProgramaUniversidad from '../components/ModalFormularioProgramaUniversidad.vue';

export default {
  name: 'ProgramaUniversidadLayout',
  mixins: [layoutMixin, apiConsumerMixin],
  components: {
    ListadoProgramaUniversidad,
    ModalFormularioProgramaUniversidadV2,
    ModalInscripcionesProgramaUniversidad,
    ModalSolicitudesPagos,
    ModalCostosPrograma,
    ModalMostrarProgramas,
    ModalModulosPrograma,
    ModalFormularioProgramaUniversidad,
    ModalMostrarProgramaUniversidadV2,
    ModalFormEstablecerPlanPagoProgramaUniversidad,
    ModalFormAgregarCEUB,
    ModalVisualizarInscripciones,
    ModalVerPdf,
  },
  props: {
    tipo: {
      type: String,
      required: true,
      validator: (value) => Object.values(TIPOS_PROGRAMAS_UNIVERSIDADES_LAYOUTS).includes(value),
    },
  },
  created() {
    this.$store.dispatch('pago/setFiltrarPorSede', this.tipo === TIPOS_PROGRAMAS_UNIVERSIDADES_LAYOUTS.SEDE);
    this.obtenerSedesUniversidades();
  },
  data() {
    return {
      nombreItem: 'Programa Universidad',
      nombreItem2: 'Solicitud Pago',
      nombreItem3: 'Costos Programa',
      nombreItem4: 'Programas',
      nombreItem5: 'Módulos Programa',
      tiposProgramasUniversidadesLayouts: TIPOS_PROGRAMAS_UNIVERSIDADES_LAYOUTS,
      estadosProgramasUniversidades: ESTADOS_PROGRAMAS_UNIVERSIDADES,
      sedesUniversidades: [],
      sedeUniversidadId: null,
      estadoProgramaUniversidad: null,
      mostrarTodasSedes: false,
      descargandoExcel: false,
      inscritosReportadosProgramaUniversidad: null,
      descargandoExcelInscritosReportados: false,
      descargandoExcelInscritosConsolidados: false,
      tieneModulos: null,
      tienePlanPago: null,
      descargandoPdf: false,
    };
  },
  mounted() {
    this.listar();
  },
  watch: {
    '$store.state.CARGO.sede.id'() {
      this.sedeUniversidadId = null;
      this.obtenerSedesUniversidades();

      if (!this.mostrarTodasSedes) {
        this.listarRestableciendoPagina();
      }
    },
    mostrarTodasSedes() {
      this.sedeUniversidadId = null;
      this.obtenerSedesUniversidades();
      this.listarRestableciendoPagina();
    },
    item(value) {
      if (value) {
        this.obtenerInscritosReportados();
      }
    },
  },
  computed: {
    ...mapGetters({
      permisosPresupuestos1: 'presupuesto/permisosPresupuestos1',
      permisosPresupuestos2: 'presupuesto/permisosPresupuestos2',
      permisosAcademicosNacional: 'pago/permisosAcademicosNacional',
      permisosGestionEmpresarial: 'pago/permisosGestionEmpresarial',
      permisosContabilidadNacional: 'pago/permisosContabilidadNacional',
    }),
    totalInscritosReportados() {
      if (!this.inscritosReportadosProgramaUniversidad) {
        return 0;
      }

      return this.inscritosReportadosProgramaUniversidad.programas.reduce(
        (total, programa) => total + Number(programa.cantidadInscritos),
        0,
      );
    },
    textoPaginacion() {
      return `Mostrando ${
        this.metadatos?.totalItems === 0 ? 0 : (this.metadatos?.paginaActual - 1) * this.metadatos?.itemsPorPagina + 1
      } - ${Math.min(
        this.metadatos?.paginaActual * this.metadatos?.itemsPorPagina,
        this.metadatos?.totalItems || 0,
      )} de ${this.metadatos?.totalItems || 0} Registros`;
    },
  },
  methods: {
    listar() {
      const params = {
        pagina: this.pagina,
        itemsPorPagina: this.itemsPorPagina,
        busqueda: this.busqueda,
        sedeUniversidadId: this.sedeUniversidadId,
        estado: this.estadoProgramaUniversidad,
        sedeId: this.mostrarTodasSedes ? null : this.$store.state.CARGO.sede.id,
        tieneModulos: this.tieneModulos,
        tienePlanPago: this.tienePlanPago,
      };

      this.obtenerDatosPaginadosConNotificacion(
        ProgramaUniversidadService.findAllPaginado,
        'items',
        'metadatos',
        this.nombreItem,
        params,
      );

      this.item = null;
    },
    async getResponseAccion(accion) {
      let response = null;

      if (accion === this.accionesAConfirmar.ELIMINAR) {
        response = await ProgramaUniversidadService.remove(this.item.id);
      }

      return response;
    },
    confirmarConsolidacion() {
      this.confirmacion.titulo = 'Consolidar';
      this.confirmacion.mensaje = /*html*/ `¿Está seguro de consolidar el Programa Universidad?
      Al consolidar, se generará el Código de Empastado
      También, <strong>No se permitirá:</strong>
      <ul>
        <li>Modificar o Eliminar el Programa Universidad</li>
        <li>Realizar Solicitudes de Inscripción</li>
        <li>Realizar Inscripciones</li>
      </ul>
      Por el contrario, <strong>Sí se permitirá</strong>:
      <ul>
        <li>Realizar Solicitudes de Pago</li>
        <li>Realizar Pagos</li>
      </ul>`;
      this.confirmacion.fnAceptar = () => this.consolidar();
      this.$refs.confirmacionRef.abrir();
    },
    async consolidar() {
      this.confirmacion.realizandoAccion = true;

      try {
        const { data } = await ProgramaUniversidadService.consolidar(this.item.id);

        this.$refs.confirmacionRef.cerrar();
        this.listar();
        this.$notify({
          group: 'notifications',
          title: this.nombreItem.toUpperCase(),
          text: data?.mensaje || 'Programa Universidad consolidado correctamente',
          type: 'success',
        });
      } catch (error) {
        window.console.log({ error });
        const data = error?.response?.data;
        const mensaje = data?.mensaje;

        this.$notify({
          group: 'notifications',
          title: this.nombreItem.toUpperCase(),
          text: mensaje || 'Error al consolidar Programa Universidad',
          type: 'error',
        });
      } finally {
        this.confirmacion.realizandoAccion = false;
      }
    },
    async obtenerSedesUniversidades() {
      await this.obtenerDatosMixin(SedeUniversidadService.findAll, 'sedesUniversidades', {
        sedeId: this.mostrarTodasSedes ? null : this.$store.state.CARGO.sede.id,
      });
    },
    handleSolcitudesPagos() {
      if (!this?.item?.planPagoUniversidadId) {
        this.$notify({
          group: 'notifications',
          title: 'Error: Plan de Pago',
          text: 'Debe asignar un plan de pago al Programa Universidad',
          type: 'error',
        });

        return;
      }

      this.$refs.modalSolicitudesPagosRef.abrir(this.accionesCrud.EDITAR, this.item);
    },
    async obtenerExcelProgramasUniversidades() {
      this.descargandoExcel = true;

      const params = {
        sedeId: this.mostrarTodasSedes ? null : this.$store.state.CARGO.sede.id,
      };

      try {
        const response = await ProgramaUniversidadExcelService.findAll({ params });
        const data = response.data;
        const blob = new Blob([data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const link = document.createElement('a');

        link.href = window.URL.createObjectURL(blob);
        link.setAttribute('download', 'programas_nacionales.xlsx');
        document.body.appendChild(link);
        link.click();

        this.$notify({
          group: 'notifications',
          title: 'Exportación exitosa',
          text: 'Programas Universidad exportados correctamente',
          type: 'success',
        });
      } catch (error) {
        window.console.error(error);

        this.$notify({
          group: 'notifications',
          title: 'Error al exportar',
          text: 'No se pudo exportar los programas universidad',
          type: 'error',
        });
      } finally {
        this.descargandoExcel = false;
      }
    },
    async obtenerInscritosReportados() {
      this.inscritosReportadosProgramaUniversidad = null;

      try {
        const params = {
          codigos: `${this.item.codigo}`,
        };

        const response = await ProgramaUniversidadService.inscritosReportados({ params });
        const data = response?.data;
        const datos = data?.datos || [];

        this.inscritosReportadosProgramaUniversidad = datos && datos.length > 0 ? datos[0] : null;
      } catch (error) {
        window.console.log({ error });
        const data = error?.response?.data;
        const mensaje = data?.mensaje;

        this.$notify({
          group: 'notifications',
          title: this.nombreItem.toUpperCase(),
          text: mensaje || 'Error al obtener inscritos reportados',
          type: 'error',
        });
      }
    },
    async obtenerExcelProgramasUniversidadesInscritosReportados(mes) {
      if (!mes) {
        return;
      }

      this.descargandoExcelInscritosReportados = true;

      try {
        const params = {
          mes,
        };
        const response = await ProgramaUniversidadExcelService.inscritosReportadosRaw({ params });
        const data = response.data;
        const blob = new Blob([data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const link = document.createElement('a');

        link.href = window.URL.createObjectURL(blob);
        link.setAttribute('download', `programas_universidad_inscritos_reportados_${mes}.xlsx`);
        document.body.appendChild(link);
        link.click();

        this.$notify({
          group: 'notifications',
          title: 'Exportación exitosa',
          text: 'Programas Universidad inscritos reportados exportados correctamente',
          type: 'success',
        });
      } catch (error) {
        window.console.error(error);

        this.$notify({
          group: 'notifications',
          title: 'Error al exportar',
          text: 'No se pudo exportar los programas universidad inscritos reportados',
          type: 'error',
        });
      } finally {
        this.descargandoExcelInscritosReportados = false;
      }
    },
    async obtenerPdfProgramaUniversidad() {
      this.descargandoPdf = true;

      try {
        const response = await ProgramaUniversidadPdfV2Service.findOne(this.item.id, {
          params: { formato: 'base64' },
        });
        const base64 = response.data.datos;
        const blob = new Blob([Buffer.from(base64, 'base64')], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);

        this.$refs.modalVerPdfRef.abrir(url);
      } catch (error) {
        window.console.error(error);
        const mensaje = error?.response?.data?.mensaje;

        this.$notify({
          group: 'notifications',
          title: this.nombreItem.toUpperCase(),
          text: mensaje || 'Error al obtener el PDF del Programa Universidad',
          type: 'error',
        });
      } finally {
        this.descargandoPdf = false;
      }
    },
    async obtenerExcelProgramasUniversidadesInscritosConsolidados(mes) {
      if (!mes) {
        return;
      }

      this.descargandoExcelInscritosConsolidados = true;

      try {
        const params = {
          mes,
        };
        const response = await ProgramaUniversidadExcelService.inscritosConsolidadosRaw({ params });
        const data = response.data;
        const blob = new Blob([data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const link = document.createElement('a');

        link.href = window.URL.createObjectURL(blob);
        link.setAttribute('download', `programas_universidad_inscritos_consolidados_${mes}.xlsx`);
        document.body.appendChild(link);
        link.click();

        this.$notify({
          group: 'notifications',
          title: 'Exportación exitosa',
          text: 'Programas Universidad inscritos consolidados exportados correctamente',
          type: 'success',
        });
      } catch (error) {
        window.console.error(error);

        this.$notify({
          group: 'notifications',
          title: 'Error al exportar',
          text: 'No se pudo exportar los programas universidad inscritos consolidados',
          type: 'error',
        });
      } finally {
        this.descargandoExcelInscritosConsolidados = false;
      }
    },
  },
};
</script>

<style scoped>
.custom-card {
  border: 1px solid #dfdfdf;
  padding: 8px;
  margin: 0px 8px 0px 8px;
}

::v-deep .custom-pagination .v-pagination__item,
::v-deep .custom-pagination .v-pagination__navigation {
  height: 28px;
  min-width: 28px;
  margin: 0px 4px;
}

::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
  padding: 0px 0;
}

::v-deep .v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}

::v-deep .v-text-field--outlined.v-input--dense .v-label {
  top: 5px;
}

::v-deep .v-text-field .v-label {
  font-weight: 400;
}
</style>
